export default "__VITE_ASSET__fT9mkKMU__"